import React from "react";
import BackUpService from "./BackUpService";
import Hero from "./hero";
import Cards from "./Cards";


function Index() {
    return (
        <div>
            <Hero />
            <BackUpService />
            <Cards />

        </div>

    );
}

export default Index;